<template>
    <div>
        <b-navbar type="light" toggleable="md" class="shadow-sm module-navbar">
            <b-navbar-toggle target="nav_dropdown_collapse"></b-navbar-toggle>
            <b-collapse id="nav_dropdown_collapse" is-nav v-if="theReturn">
                <b-navbar-nav
                    @click="saveEditProfile()"
                    v-if="
                        _hasAccess('billing.return.update') &&
                        isEditMode &&
                        isactiveClient
                    "
                >
                    <b-nav-item>
                        <i class="cus-disk"></i>Save Return
                    </b-nav-item>
                    <b-nav-item
                        @click="cancelEdit()"
                        v-if="_hasAccess('billing.return.update')"
                    >
                        <i class="cus-cancel"></i>Cancel
                    </b-nav-item>
                </b-navbar-nav>
                <b-navbar-nav v-else-if="!isEditMode">
                    <b-nav-item
                        @click="goToEdit()"
                        v-if="
                            _hasAccess('billing.return.update') &&
                            isactiveClient
                        "
                    >
                        <i class="cus-page-white-edit"></i>Edit Return
                    </b-nav-item>
                    <b-nav-item
                        :disabled="loadingTransactionId"
                        @click="openReturnPost()"
                        v-if="
                            _hasAccess('billing.return.post') &&
                            isactiveClient &&
                            !theReturn.status &&
                            itemCount > 0
                        "
                    >
                        <i class="cus-accept"></i>Post Return
                    </b-nav-item>
                    <b-nav-item
                        @click="openDeleteReturnModal()"
                        v-if="
                            _hasAccess('billing.return.delete') &&
                            isactiveClient &&
                            !fullDetails.isCreditCardRefunds
                        "
                    >
                        <i class="cus-delete"></i>Delete Return
                    </b-nav-item>
                    <b-nav-item-dropdown
                        v-if="
                            (_hasAccess('billing.return.email') ||
                                _hasAccess('billing.return.print')) &&
                            theReturn.status
                        "
                        :disabled="isExporting"
                    >
                        <template slot="button-content">
                            <spinner v-if="isExporting" />
                            <span v-else>
                                <i class="cus-page-attach"></i>
                                Export
                            </span>
                        </template>
                        <b-dropdown-item
                            v-if="_hasAccess('billing.return.email')"
                            @click="openReturnEmailModal()"
                        >
                            <i class="cus-email"></i>
                            Email Return
                        </b-dropdown-item>
                        <b-dropdown-item
                            v-if="_hasAccess('billing.return.print')"
                            @click="generatePrintPdf()"
                        >
                            <i class="cus-printer"></i>
                            Print Return
                        </b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </b-collapse>
            <b-navbar-nav class="ml-auto">
                <b-nav-form
                    @click="$refs['select-billing'].focus()"
                    @contextmenu="rightClickHandler"
                    class="ml-auto"
                >
                    <vet-select-billing
                        ref="select-billing"
                        :key="'search' + searchItemKey"
                        class="mr-sm-2 w-100 search nav-search show-actions"
                    />
                </b-nav-form>
            </b-navbar-nav>
        </b-navbar>
        <router-view ref="routerView"></router-view>
        <div v-if="theReturn">
            <return-delete-modal
                modal-id="return-delete-modal"
                :return-details="theReturn"
                @reload="redirectToDashoard()"
            />
            <return-email-modal
                modal-ref="returnEmailModal"
                ref="returnEmailModal"
                :return-details="theReturn"
                :client="theReturn.client"
            />
            <post-modal
                ref="postModal"
                modal-ref="postModal"
                @reload="refreshPage()"
            />
        </div>
    </div>
</template>

<script>
/**
 * @name ReturnDetailPageNavbar
 * @description Details page of selected Return
 * @see apps/application/views/staff/billing/return/return/navbar.php
 */
import BillingReturnServices from "@/services/billing/billing-return";
import VetSelectBilling from "@/module/commons/vet-select-billing";
import SettingMixins from "@/mixins/settings";
import RELATIONS from "@/constants/relations.js";
import EXTENSIONS from "@/constants/extensions";
import Spinner from "@/components/elements/spinner";

export default {
    components: {
        VetSelectBilling,
        Spinner,
        ReturnDeleteModal: () =>
            import("@/components/client-returns/return-delete-modal"),
        ReturnEmailModal: () =>
            import("@/components/client-returns/return-email-modal"),
        PostModal: () => import("@/components/billing-returns/post-modal")
    },
    props: {},
    mixins: [SettingMixins],
    data() {
        return {
            searchItemKey: 0,
            searchItem: null,
            isExporting: false,
            loadingTransactionId: false
        };
    },
    computed: {
        isEditMode() {
            return this.$store.getters["returnDetails/isEditMode"];
        },
        theReturn() {
            return this.$store.getters["returnDetails/returnDetails"];
        },
        fullDetails() {
            return this.$store.getters["returnDetails/fullDetails"];
        },
        itemCount() {
            return this.$store.getters["returnDetails/itemCount"];
        },
        isactiveClient() {
            let client = this.theReturn.client
                ? this.theReturn.client.single_business_actor
                : null;

            if (client) {
                return (
                    client.isactive &&
                    client.relation_type == RELATIONS.BUSINESS_ACTOR.CLIENT
                );
            }

            return false;
        }
    },
    watch: {},
    mounted() {},
    destroyed() {},

    methods: {
        goToAppPage() {
            window.open(
                `${process.env.CI_APPS}${this.theReturn.ci_url}`,
                "_blank"
            );
        },
        redirectToDashoard() {
            this.$router.push({ name: "billing_dashboard" });
        },
        rightClickHandler(e) {
            if (e.which === 3) {
                this.$refs["select-billing"].focus();
            }
        },
        goToEdit() {
            this.reloadSettings().then(() => {
                this.$store.commit("returnDetails/setEditMode", true);
            });
        },
        cancelEdit() {
            this.$store.commit("returnDetails/setEditMode", false);
        },
        async reloadSettings() {
            return this.getBusinessSettings();
        },
        openDeleteReturnModal() {
            this.$bvModal.show("return-delete-modal");
        },
        openReturnEmailModal() {
            this.$refs.returnEmailModal.open();
        },
        async openReturnPost() {
            let valid = true;
            let self = this;
            self.loadingTransactionId = true;
            if (this._isExtensionEnabled(EXTENSIONS.CODE.CODE_STRIPE)) {
                await BillingReturnServices.postReturnStripeInteract({
                    return_id: self.theReturn.id
                }).then(result => {
                    if (result.message.code == 200) {
                        if (result.message.type == "interac_present") {
                            self.theReturn.isInteracPayment = true;
                            self.theReturn.isInteracPaymentData = {
                                trans_type: result.message.type,
                                charge: result.message.charge,
                                payment_intent: result.message.payment_intent
                            };
                        }
                    } else if (result.message.code == 401) {
                        valid = false;
                        self.loadingTransactionId = false;
                        this._message(
                            result.message.message,
                            "danger",
                            5000,
                            '50%'
                        );
                    } else {
                        valid = false;
                        self.loadingTransactionId = false;
                        this._message(result.message.message, "danger");
                    }
                });
            }
            if (valid) {
                self.loadingTransactionId = false;
                this.$refs.postModal.open(self.theReturn);
            }
        },
        generatePrintPdf() {
            this.isExporting = true;
            BillingReturnServices.generatePrintPdf(this.theReturn.id)
                .then(response => {
                    if (
                        response.code === 200 &&
                        response.resource &&
                        response.resource.path
                    ) {
                        this._redirect(response.resource.path, true);
                    } else {
                        throw "error";
                    }
                })
                .catch(error => {
                    this._message("Error : Unable print the return", "danger");
                    console.error(error);
                })
                .finally(() => {
                    this.isExporting = false;
                });
        },
        refreshPage() {
            this.$root.$emit("refresh-return-page");
        },
        saveEditProfile() {
            this.$refs.routerView.saveEdit();
        }
    }
};
</script>
